import { cn } from '@quadralize/utils'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { motion } from 'framer-motion'
import * as React from 'react'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = React.forwardRef<
  React.ComponentRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    portalled?: boolean
    container?: HTMLElement | null
  }
>(({ className, align = 'center', sideOffset = 4, portalled = true, container, ...props }, ref) => {
  const content = (
    <PopoverPrimitive.Content ref={ref} align={align} sideOffset={sideOffset} asChild {...props}>
      <motion.div
        initial={{ opacity: 0, scale: 0.9, filter: 'blur(4px)' }}
        animate={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
        transition={{
          type: 'spring',
          duration: 0.3,
          bounce: 0,
        }}
        style={{ transformOrigin: 'var(--radix-popover-content-transform-origin)' }}
        className={cn(
          'z-50 w-72 rounded-xl border border-border-strong bg-bg-elevated p-4 text-text-primary shadow-md outline-none overflow-hidden',
          'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
          className,
        )}
      >
        {props.children}
      </motion.div>
    </PopoverPrimitive.Content>
  )

  if (!portalled) {
    return content
  }

  return <PopoverPrimitive.Portal container={container}>{content}</PopoverPrimitive.Portal>
})
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger }
